import { endEventTimer, logEventDurationMetric, startEventTimer } from '@amzn/atoz-shiftapp-metrics';
import { useState, useEffect } from 'react';
export function useEventDurationLogger(_a) {
    var eventName = _a.eventName, pageName = _a.pageName, isGqlFetchingData = _a.isGqlFetchingData;
    var _b = useState(false), eventInProgress = _b[0], setEventInProgress = _b[1];
    var _c = useState(false), isGqlInvoked = _c[0], setIsGqlInvoked = _c[1];
    useEffect(function () {
        if (isGqlFetchingData && eventInProgress) {
            setIsGqlInvoked(true);
        }
        if (!eventInProgress) {
            setIsGqlInvoked(false);
        }
    }, [isGqlFetchingData, eventInProgress, setIsGqlInvoked]);
    var logEventDuration = function () {
        if (eventInProgress) {
            setEventInProgress(false);
            endEventTimer(eventName);
            logEventDurationMetric(eventName, pageName, isGqlInvoked);
        }
    };
    var startEventDurationLogger = function () {
        setEventInProgress(true);
        startEventTimer(eventName);
    };
    return { startEventDurationLogger: startEventDurationLogger, logEventDuration: logEventDuration };
}
